module.exports = __webpack_public_path__ + "static/media/ico_upload.1742ac98.svg";